import { render, staticRenderFns } from "./PopupContainer.vue?vue&type=template&id=3f27e151&scoped=true"
import script from "./PopupContainer.vue?vue&type=script&lang=js"
export * from "./PopupContainer.vue?vue&type=script&lang=js"
import style0 from "./PopupContainer.vue?vue&type=style&index=0&id=3f27e151&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f27e151",
  null
  
)

export default component.exports